import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import PageRouter from "./Router/PageRouter";
// import PageRoutes from "./routes";

function App() {
  return (
    <Router>
      <PageRouter />
    </Router>
  );
}

export default App;
